import { IconName } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { LazyExoticComponent } from 'react';

import { Permission } from '@model/permission.model';

import { PageHeaderProps } from 'src/shared/layout/page-layout/page.layout';

type RouteController = () => React.JSX.Element;

export enum GroupEnum {
  DASHBOARD = 'dashboard',
  EMSP = 'emsp',
  USERS_VE = 'users_ve',
  CUSTOMERS = 'customers',
  CHARGE_POINTS = 'charge-points',
  SUPPORT = 'support',
}

export type RoutingConfigurationModel = PageHeaderProps & {
  route: string;
  controller: RouteController | LazyExoticComponent<RouteController>;
  items?: RoutingConfigurationModel[];
  icon?: IconName;
  showInMenu?: boolean;
  parentRoute?: string;
  group?: GroupEnum;
  permission?: Permission;
};
